import * as types from "../constants/actionTypes";
import initialState from "./initialState";

const claimsAccountsReducer = (
  state = initialState.claimsAccountsData,
  action
) => {
  switch (action.type) {
    case types.FETCH_CLAIMS_ACCOUNTS_STARTED:
      return {
        ...state,
        accounts: null,
        isLoading: true,
        error: null
      };
    case types.FETCH_CLAIMS_ACCOUNTS_SUCCEEDED:
      return {
        ...state,
        accounts: action.payload,
        isLoading: false,
        error: null
      };
    case types.FETCH_CLAIMS_ACCOUNTS_FAILED:
      return {
        ...state,
        accounts: null,
        isLoading: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default claimsAccountsReducer;
